module.exports = __webpack_public_path__ + "img/guide-page-tip.382126b9.png";